export default __webpack_public_path__ + "static/opsec-42e73489e88a6dc76aee4ede741767f2.png";